import * as React from 'react';
import Button from '../../../../../../components/common/Button';
import { downloadFile } from 'src/utils/downloadHelper';
import './BoxConfirm.scss';
import { currencyFormatter } from 'src/utils/currencyFormatter';
import ShippingLabelToPrint from '../ShippingLabelToPrint';
import ReactToPrint from 'react-to-print';
import localeFormatingInstance from 'src/translation/localeFormating';

interface IBoxConfirm {
  distributionSelectedOption: string;
  handleDistributionChangeOption: (e: any) => void;
  rmaSelected: string;
  handleGenerateShippingLabel:(e:any,toShippingWarehouseCode:string)=>void;
  boxResponseData:any[];
  totalShippingCharge:number;
  handleConfirmationCancel: (e:any)=>void;
  handleUpsConfirmation: (e:any)=>void;
  shippingType:string;
  totalItemPrice:number;
  t?: any;
}
const BoxConfirm: React.FC<IBoxConfirm> = props => {
  const {
    rmaSelected,
    distributionSelectedOption,
    handleDistributionChangeOption,
    handleGenerateShippingLabel,
    boxResponseData,
    totalShippingCharge,
    handleConfirmationCancel,
    handleUpsConfirmation,
    shippingType,
    totalItemPrice,
    t
  } = props;

  const componentRef = React.useRef();
  const[labelSignleImage, setLabelSignleImage]= React.useState<any>([]); 
  const [isDownloadingDetails, setIsDownloadingDetails] = React.useState<boolean>(false);
  const [documentTitle, setDocumentTitle] = React.useState<string>('');

  const downloadPdf=(imageLink:string)=>{
     setLabelSignleImage(imageLink);
  }

   const getEstimatedRefundAmount = () => {
    const refundSAmout=totalItemPrice-totalShippingCharge;
    return refundSAmout;
  };
  const estimatedRefundAmout=getEstimatedRefundAmount();

  return (
    <div className="rp-returns-table">
      <div style={{ display: 'none' }}>
        <ShippingLabelToPrint
          ref={componentRef}
          shippingLabel={boxResponseData}
        />
      </div>
      <div className="container-fluid">
        <div className="row rp-returns-table-headers">
          <div className="col-9">
            <p className="rp-returns-table-header">{t('myReturns.boxNo')} </p>
          </div>
          <div className="col-6">
            <p className="rp-returns-table-header">
              {t('myReturns.dimension')}
            </p>
          </div>

          <div className="col-2">
            <p className="rp-returns-table-header">
              {t('myReturns.shippingCharge')}
            </p>
          </div>

          <div className="col-2">
            <p className="rp-returns-table-header">
              {t('myReturns.tax')}
            </p>
          </div>
        </div>
      </div>
      <div className="rp-returns-table-row-container">
        {/* Rows here */}
      
      {boxResponseData.map((res, i) => ( 
      <div className="rp-returns-row" key={i}>
      <div className="container-fluid">
        <div className="row">
          <div className="d-flex align-items-center col-9">
            <p className="rp-returns-row-container">
             {i+1}
            </p>
          </div>
          
          <div className="d-flex align-items-center col-6">
            
          <p className="rp-returns-row-container">
            
          <div className="box-shipping-container">

          <div className='dropdown-container'>
          Length 
          <label className='boxConfirmLeft'> <strong>{res.boxLength}</strong></label>
           </div>
          
           <div className='dropdown-container'>
          Width 
          <label className='boxConfirmLeft'> <strong>{res.boxWidth}</strong></label>
           </div>

           <div className='dropdown-container'>
          Height 
          <label className='boxConfirmLeft'> <strong>{res.boxHeight}</strong></label>
           </div>

           <div className='dropdown-container'>
           Weight 
          <label className='boxConfirmLeft'> <strong>{res.boxWeight}</strong></label>
           </div>

          </div>
          </p>
          </div>

          <div className="d-flex align-items-center col-2">
          <p className="rp-returns-row-container">
          <div className="box-shipping-container">
          <div className='dropdown-container'>
           <label className='boxLeft'><strong>{currencyFormatter(res.price)}</strong></label>
           
           </div> 
          
          </div>
          </p>
          </div>


          <div className="d-flex align-items-center col-2">
          <p className="rp-returns-row-container">
          <div className="box-shipping-container">
          <div className='dropdown-container'>
           <label className='boxLeft'>null</label>
           </div> 
          
          </div>
          </p>
          </div>

        </div>
      </div>
      
    </div>
     ))}
        {/* End Rows here */}

        <div className="d-flex align-items-center col-12">
          <p className="confirm-box-total"><strong>Total Shipping Charge {currencyFormatter(totalShippingCharge)}</strong></p>
        </div>

        <div className="d-flex align-items-center col-12">
          <p className="confirm-box-total"><strong>Estimated Refund Amount {currencyFormatter(estimatedRefundAmout)}</strong></p>
        </div>

        <div className="d-flex align-items-center col-12">

        {isDownloadingDetails && (
                        <div className="rp-box-confirm-desktop-loading">
                          <div className="loadingio-spinner-rolling-x8i9qka9tdm">
                            <div className="ldio-9coovtt1mti">
                              <div />
                            </div>
                          </div>
                        </div>
                      )}

          <p className="confirm-box-shipping-label">

          <ReactToPrint
              onBeforeGetContent={() => {
                setDocumentTitle(document.title);
                document.title = `Shipping-Label-${localeFormatingInstance.getNowDate('short')}.pdf`;
                setIsDownloadingDetails(true);
                setLabelSignleImage(boxResponseData);
              }}
              onAfterPrint={() => {
                document.title = documentTitle;
                setIsDownloadingDetails(false);
              }}
              trigger={() => (
                <div
                  className={`rp-box-confirm-desktop-print ${isDownloadingDetails &&
                    'disabled'}`}
                >
                  <i className="rpds-print" />
                  <p>Print Shipping Lables</p>
                </div>
              )}
              content={() => componentRef.current}
            />


          </p>
        </div>

      </div>

      <div className="container-fluid">
      <button className="login">
          <Button
            buttonClass="primary-button login-button"
            label={t('myReturns.cancel')}
            action={handleConfirmationCancel}
            disabled={shippingType==="PREPAID_SHIPPING"? true:false}
          />
        </button>  
      <button className="login">
          <Button
            buttonClass="primary-button login-button"
            label={t('myReturns.confirm')}
            action={handleUpsConfirmation}
            disabled={shippingType==="PREPAID_SHIPPING"? true:false}
          />
        </button>
      </div>
    </div>
   
  );
};

export default BoxConfirm;
